// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mobile-specific fixes for search results */

/* Ensure touch events work properly on iOS Safari */
@supports (-webkit-touch-callout: none) {
  .__Search_result_box {
    /* Fix for iOS Safari touch events */
    -webkit-user-select: none;
    -webkit-touch-callout: none;
    pointer-events: auto !important;
  }
  
  /* Make clickable elements more responsive on touch */
  .music-item,
  .artist-card,
  .MuiCard-root {
    cursor: pointer !important;
    -webkit-user-select: none;
    pointer-events: auto !important;
    position: relative;
    z-index: 1;
  }
  
  /* Prevent zoom on double tap */
  .music-item *,
  .artist-card *,
  .MuiCard-root * {
    touch-action: manipulation;
    pointer-events: auto !important;
  }
}

/* Android-specific fixes */
@media (hover: none) and (pointer: coarse) {
  /* Increase touch targets for mobile */
  .music-item {
    min-height: 60px;
    padding: 14px;
  }
  
  .artist-card {
    min-height: 130px;
    padding: 14px;
  }
  
  /* Make menu icons larger on mobile */
  .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium {
    font-size: 1.75rem;
    padding: 4px;
  }
  
  /* Ensure proper spacing for touch */
  .__music_thumb {
    min-width: 52px;
    width: 52px;
    height: 52px;
  }
}

/* General mobile improvements */
@media (max-width: 768px) {
  /* Prevent text selection on mobile */
  .__Search_result_box {
    -webkit-user-select: none;
    user-select: none;
  }
  
  /* Improve scroll performance */
  .__main_pading {
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
  }
  
  /* Add active states for better feedback */
  .music-item:active,
  .artist-card:active,
  .MuiCard-root:active {
    opacity: 0.8;
    transition: opacity 0.1s ease;
  }
  
  /* Ensure proper z-index stacking on mobile */
  .ProfileMenu {
    z-index: 1000000002 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SearchResult/mobile-fixes.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C,oDAAoD;AACpD;EACE;IACE,oCAAoC;IACpC,yBAAyB;IACzB,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA,qDAAqD;EACrD;;;IAGE,0BAA0B;IAC1B,yBAAyB;IACzB,+BAA+B;IAC/B,kBAAkB;IAClB,UAAU;EACZ;;EAEA,+BAA+B;EAC/B;;;IAGE,0BAA0B;IAC1B,+BAA+B;EACjC;AACF;;AAEA,2BAA2B;AAC3B;EACE,sCAAsC;EACtC;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA,qCAAqC;EACrC;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA,oCAAoC;EACpC;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;AACF;;AAEA,gCAAgC;AAChC;EACE,qCAAqC;EACrC;IACE,yBAAyB;IAGzB,iBAAiB;EACnB;;EAEA,+BAA+B;EAC/B;IACE,iCAAiC;IACjC,uBAAuB;EACzB;;EAEA,0CAA0C;EAC1C;;;IAGE,YAAY;IACZ,6BAA6B;EAC/B;;EAEA,6CAA6C;EAC7C;IACE,8BAA8B;EAChC;AACF","sourcesContent":["/* Mobile-specific fixes for search results */\n\n/* Ensure touch events work properly on iOS Safari */\n@supports (-webkit-touch-callout: none) {\n  .__Search_result_box {\n    /* Fix for iOS Safari touch events */\n    -webkit-user-select: none;\n    -webkit-touch-callout: none;\n    pointer-events: auto !important;\n  }\n  \n  /* Make clickable elements more responsive on touch */\n  .music-item,\n  .artist-card,\n  .MuiCard-root {\n    cursor: pointer !important;\n    -webkit-user-select: none;\n    pointer-events: auto !important;\n    position: relative;\n    z-index: 1;\n  }\n  \n  /* Prevent zoom on double tap */\n  .music-item *,\n  .artist-card *,\n  .MuiCard-root * {\n    touch-action: manipulation;\n    pointer-events: auto !important;\n  }\n}\n\n/* Android-specific fixes */\n@media (hover: none) and (pointer: coarse) {\n  /* Increase touch targets for mobile */\n  .music-item {\n    min-height: 60px;\n    padding: 14px;\n  }\n  \n  .artist-card {\n    min-height: 130px;\n    padding: 14px;\n  }\n  \n  /* Make menu icons larger on mobile */\n  .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium {\n    font-size: 1.75rem;\n    padding: 4px;\n  }\n  \n  /* Ensure proper spacing for touch */\n  .__music_thumb {\n    min-width: 52px;\n    width: 52px;\n    height: 52px;\n  }\n}\n\n/* General mobile improvements */\n@media (max-width: 768px) {\n  /* Prevent text selection on mobile */\n  .__Search_result_box {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n  }\n  \n  /* Improve scroll performance */\n  .__main_pading {\n    -webkit-overflow-scrolling: touch;\n    scroll-behavior: smooth;\n  }\n  \n  /* Add active states for better feedback */\n  .music-item:active,\n  .artist-card:active,\n  .MuiCard-root:active {\n    opacity: 0.8;\n    transition: opacity 0.1s ease;\n  }\n  \n  /* Ensure proper z-index stacking on mobile */\n  .ProfileMenu {\n    z-index: 1000000002 !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
